module.exports = __webpack_public_path__ + "img/0220624140657.9fbc4810.png";